<div class="content-with-chat h-full">
	@if (!hidePlayerMobile()) {
		<div class="video-section" [class.has-gap]="!layoutService.isLayout(VideoLayout.SINGLE)">
			<div
				class="video-container"
				id="videoContainer"
				[ngClass]="containerAspectRatioClass"
				[class.layout-single]="layoutService.isLayout(VideoLayout.SINGLE)"
				[class.layout-side-by-side]="layoutService.isLayout(VideoLayout.SIDE_BY_SIDE)"
				[class.layout-stacked]="layoutService.isLayout(VideoLayout.STACKED)"
				[class.layout-large-left]="layoutService.isLayout(VideoLayout.LARGE_LEFT)"
				[class.layout-large-right]="layoutService.isLayout(VideoLayout.LARGE_RIGHT)"
				[class.layout-grid-2x2]="layoutService.isLayout(VideoLayout.GRID_2X2)"
				[class.has-gap]="!layoutService.isLayout(VideoLayout.SINGLE)"
			>
				<!-- Main Video (always shown) -->
				<vb-lxp-video-slot
					#livestreamPlayerSlot
					class="aspect-video"
					[ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mt-auto' : ''"
					id="mainVideo"
					[label]="'Main Feed'"
					[showBadge]="true"
					[time]="'3:42:18'"
					[isLive]="true"
					[progressPercent]="55"
					[volumePercent]="70"
					(playerClosed)="onPlayerClosed($event)"
				/>

				@if (
					layoutService.isLayout(VideoLayout.SIDE_BY_SIDE) ||
					layoutService.isLayout(VideoLayout.STACKED)
				) {
					<vb-lxp-video-slot
						#livestreamPlayerSlot
						class="aspect-video"
						[ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'h-full' : ''"
						[label]="'Onboard Camera'"
						[showBadge]="true"
						[time]="'3:42:18'"
						[isLive]="true"
						[src]="''"
						(playerClosed)="onPlayerClosed($event)"
					/>
				}

				@if (
					!isMobile() &&
					(layoutService.isLayout(VideoLayout.LARGE_LEFT) ||
						layoutService.isLayout(VideoLayout.LARGE_RIGHT) ||
						layoutService.isLayout(VideoLayout.GRID_2X2))
				) {
					<vb-lxp-video-slot
						#livestreamPlayerSlot
						class="aspect-video mt-auto"
						[label]="'Pit Lane'"
						[showBadge]="true"
						[time]="'3:42:18'"
						[isLive]="true"
						[src]="''"
						(playerClosed)="onPlayerClosed($event)"
					/>
					<vb-lxp-video-slot
						#livestreamPlayerSlot
						class="aspect-video mb-auto"
						[label]="'Turn 1'"
						[showBadge]="true"
						[time]="'3:42:18'"
						[isLive]="true"
						[src]="''"
					/>
				}

				@if (!isMobile() && layoutService.isLayout(VideoLayout.GRID_2X2)) {
					<vb-lxp-video-slot
						#livestreamPlayerSlot
						class="aspect-video"
						[ngClass]="layoutService.isLayout(VideoLayout.GRID_2X2) ? 'mb-auto' : ''"
						[label]="'Paddock'"
						[showBadge]="true"
						[time]="'3:42:18'"
						[isLive]="true"
						[src]="''"
						(playerClosed)="onPlayerClosed($event)"
					/>
				}
			</div>

			<!-- Race Info Bar -->
			@if (raceStatus()) {
				<div class="race-info-bar">
					<div class="race-info-item">
						<span class="race-info-label">LAP</span>
						<span class="race-info-value lap-value">{{ raceStatus()?.elapsedLaps | json }}</span>
					</div>
					<div class="race-info-item">
						<span class="race-info-label">ELAPSED</span>
						<span class="race-info-value">{{ timeStatus()?.elapsedTime | timespan }}</span>
					</div>
					<div class="race-info-item">
						<span class="race-info-label">REMAINING</span>
						<span class="race-info-value">{{ timeStatus()?.remainingTime | timespan }}</span>
					</div>
					@if (!isMobile()) {
						<!--<div class="race-info-item">
          <span class="race-info-label">REMAINING</span>
          <span class="race-info-value">~28:00</span>
        </div>
        <div class="race-info-item">
          <span class="race-info-label">TRACK TEMP</span>
          <span class="race-info-value">42°C</span>
        </div>
        <div class="race-info-item">
          <span class="race-info-label">CONDITIONS</span>
          <span class="race-info-value conditions-value">
            <span class="conditions-icon">☀️</span> Dry
          </span>
        </div>-->
					}
				</div>
			}
		</div>
	}

	<!-- Chat Panel -->
	<div class="panel-container" [ngClass]="hidePlayerMobile() ? 'grow-1' : ''">
		<vb-lxp-panel
			#timingPanel
			class="timing-panel-host"
			[panelKey]="'timing'"
			[defaultOpenState]="true"
			[panelClass]="hidePlayerMobile() ? 'timing-panel max-h-full!' : 'timing-panel'"
			[panelHeaderClass]="'timing-panel-header'"
			[panelBodyClass]="'timing-panel-body-wrapper vb-lxp-panel-body-scroll'"
			[disablePin]="isMobile() || false"
			[ngClass]="{
				'timing-panel-open': timingPanel.isOpen(),
				'timing-panel-more-info': moreColumns(),
				'grow-1': timingPanel.isPinned() && timingPanel.isOpen(),
			}"
		>
			<button
				before-pin-action
				class="open-btn"
				(click)="openFullTimingPage()"
				type="button"
				aria-label="Open full timing page"
			>
				<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
					<path
						d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"
					></path>
				</svg>
			</button>
			<div header>
				<div class="flex gap-2 font-semibold">
					<span class="text-xl">Live Timing</span>
					<button
						class="header-btn"
						(click)="openFullTimingPage()"
						target="_blank"
						[title]="'Full Timing'"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							fill="currentColor"
							class="bi bi-arrows-fullscreen"
							viewBox="0 0 16 16"
						>
							<path
								fill-rule="evenodd"
								d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
							/>
						</svg>
					</button>
					<button
						class="header-btn w-12!"
						(click)="openFullMapPage()"
						target="_blank"
						[title]="'Full Map'"
					>
						Map
					</button>
				</div>
				<div class="flex justify-inherit gap-2 my-2 font-semibold">
					<span>Race Feed: </span>
					<vb-lxp-checkbox
						[(checked)]="livestreamViewService.isMainStreamSelected"
						(checkedChange)="livestreamViewService.onMainStreamToggled($event)"
						><span class="imsa-main-stream-text">Main Stream</span></vb-lxp-checkbox
					>
					@if (showTwitchStreamSelector) {
						<vb-lxp-checkbox
							[(checked)]="livestreamViewService.isTwitchStreamSelected"
							(checkedChange)="onTwitchStreamToggled($event)"
							>Twitch</vb-lxp-checkbox
						>
					}
				</div>
				<div class="flex items-center">
					<vb-lxp-switch [(checked)]="moreColumns" [leftLabel]="'More Info'"></vb-lxp-switch>
					<app-race-class
						class="absolute right-2"
						[classes]="raceSessionService.raceClasses$ | async"
						(selectionChange)="onClassSelectionChange($event)"
					></app-race-class>
				</div>
			</div>
			<div body>
				<vb-lxp-timing-tower
					class="w-full sector-secondary"
					[enableMoreColumns]="moreColumns()"
					[selectedClasses]="selectedClasses()"
					[activeClass]="'active-tower-item'"
					[activeNumberClass]="'text-secondary'"
					(selectionAdded)="onTimingTowerSelectionAdded($event)"
					(selectionRemoved)="onTimingTowerSelectionRemoved($event)"
				></vb-lxp-timing-tower>
			</div>
		</vb-lxp-panel>
		<vb-lxp-panel
			#chatPanel
			[panelKey]="'chat'"
			[panelClass]="'chat-panel'"
			[panelHeaderClass]="'chat-panel-header'"
			[panelBodyClass]="'chat-panel-body-wrapper px-1'"
			[disablePin]="isMobile()!"
			[ngClass]="chatPanel.isPinned() && chatPanel.isOpen() ? 'chat-panel-pinned grow-1' : ''"
		>
			<div header class="chat-header-content">
				<div class="chat-header-main">
					<span>{{ streamChatTitle }}</span>
					@if (enableStreamChatPopout) {
						<button
							type="button"
							class="chat-popout-btn"
							(click)="openStreamChatPopout()"
							aria-label="Open stream chat in a new window"
							title="Pop out chat"
						>
							<svg
								fill="none"
								stroke="currentColor"
								stroke-width="2"
								viewBox="0 0 24 24"
								aria-hidden="true"
							>
								<path
									d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"
								></path>
							</svg>
						</button>
					}
				</div>
			</div>
			<div body>
				<app-twitch-chat></app-twitch-chat>
			</div>
		</vb-lxp-panel>
	</div>
</div>
